import { ProductListDTO } from '../product/product-list.dto';
import { TeamAccessDTO } from '../team/team-access.dto';

export class ProductGroupDTO extends TeamAccessDTO {

    name: string;

    description: string;

    products: Array<ProductListDTO>;

}
